<template>
    <div class="smooth-pk-page">
        <SmoothPktContent />
    </div>
</template>

<script>

import headers from "../models/headers";
import SmoothPktContent from "../components/smooth-pk/smoothPktContent.vue";

export default {
    components: {
        SmoothPktContent
    },
    metaInfo: headers.pkPage(),
}
</script>
